import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IEditHallPayload } from '@app-store/slices/hall/edit'
import { notification } from 'antd'

interface TaskAction extends Action {
    payload: IEditHallPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.hall.edit

function* editHallSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.patch(`/meeting/hall/${payload.hallId}`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            notification.success({
                message: 'Hall edited successfully.'
            })
            if (payload.sagaCB) {
                payload.sagaCB?.onSuccess()
            }
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* editHallSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editHallSagaTask)
}

export default editHallSaga
